import React, { useEffect, useRef } from 'react';
import { Header } from './Header';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';

// 👇 importa la store y el hook de red
import { jornadaStore } from '../../data/jornadaStore';
import { useNetwork } from '../../hooks/useNetwork';

export const PrivateLayout = () => {
  const { auth, loading } = useAuth();
  const location = useLocation();

  // evita bootstraps duplicados cuando react monta/desmonta
  const bootstrappedRef = useRef(false);

  // 1) Mantén la store sincronizada con el estado de red del navegador
  useNetwork((isOnline) => {
    jornadaStore.setOnline(isOnline);
  });

  // 2) Bootstrap de datos cuando ya tenemos al usuario
  useEffect(() => {
    if (!auth?.id) return;
    if (bootstrappedRef.current) return;

    bootstrappedRef.current = true;

    // inicializa el flag online y arranca la store (precarga centros + activa)
    jornadaStore.setOnline(navigator.onLine);
    jornadaStore.bootstrap().catch((e) => {
      // no bloquea la UI si falla (p. ej. offline duro)
      console.warn('[PrivateLayout] bootstrap jornadaStore:', e?.message);
    });
  }, [auth?.id]);

  // logs opcionales
  // console.log("Estado de auth en PrivateLayout:", auth);
  // console.log("Estado de loading en PrivateLayout:", loading);

  if (loading) return <div>Cargando...</div>;

  if (!auth || !auth.id) {
    return <Navigate to="/" replace />;
  }

  if (location.pathname === "/app") {
    return <Navigate to="/app/inicio" replace />;
  }

  return (
    <>
      <Header />
      {/* 👆 si ese texto era solo aclaración, conviértelo en comentario */}
      <section id="content" className="layout-content">
        <Outlet />
      </section>
    </>
  );
};
